import {
  JobEditSystemFormData,
  JobFormSection,
} from "@/pages/recruit/jobs/edit/components/job-edit.type.ts";
import { ApiFieldTypes } from "@/types/custom-field.types.ts";
import { JobStatus } from "@/types/recruit/job.types.ts";

export const jobFieldNames: Partial<Record<ApiFieldTypes, keyof JobEditSystemFormData>> = {
  [ApiFieldTypes.job_title]: "title",
  [ApiFieldTypes.job_public_title]: "public_title",
  [ApiFieldTypes.job_department]: "department_id",
  [ApiFieldTypes.job_division]: "division_id",
  [ApiFieldTypes.job_job_profile]: "job_profile_id",
  [ApiFieldTypes.job_location]: "location_id",
  [ApiFieldTypes.job_priority]: "priority",
  [ApiFieldTypes.job_pipeline]: "pipeline_id",
  [ApiFieldTypes.job_approval_policy]: "approval_policy_id",
  [ApiFieldTypes.job_recruiters]: "recruiters_config",
  [ApiFieldTypes.job_stakeholders]: "stakeholders_config",
  [ApiFieldTypes.job_salary_min]: "salary_min",
  [ApiFieldTypes.job_salary_max]: "salary_max",
  [ApiFieldTypes.job_currency]: "currency_code",
  [ApiFieldTypes.job_description]: "description",
  [ApiFieldTypes.job_requirements]: "requirements",
  [ApiFieldTypes.job_responsibilities]: "responsibilities",
  [ApiFieldTypes.job_conditions]: "conditions",
  [ApiFieldTypes.job_files]: "files",
};

export function getJobFormSections(sections: JobFormSection[], isApprovalsEnabled: boolean) {
  return sections
    .map((section) => ({
      ...section,
      fields: section.fields.filter(
        (field) =>
          (field.type === ApiFieldTypes.custom || field.type in jobFieldNames) &&
          (field.type !== ApiFieldTypes.job_approval_policy || isApprovalsEnabled)
      ),
    }))
    .filter((section) => section.fields.length > 0);
}

export function isJobMandatoryStatus(status: JobStatus) {
  return status !== JobStatus.draft && status !== JobStatus.archived;
}

export function isJobFieldValueEmpty(value: unknown) {
  if (value === null || value === undefined) return true;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === "string") return value.trim() === "";
  return false;
}
